import { ResolvedLocalizedContent } from "@/modules/assessments/types/test.interface";

/**
 * Types for GET /assessments/invites/:inviteId/demographics (GetDemographicsResponse).
 * The API defines questions; the client renders them generically. Question text and choice
 * labels arrive already resolved to the invite locale.
 */
export interface DemographicChoice {
  key: string;
  label: ResolvedLocalizedContent;
  displayOrder: number;
}

export interface DemographicQuestion {
  questionId: number;
  key: string;
  text: ResolvedLocalizedContent;
  type: "single_select" | "multi_select";
  choices: DemographicChoice[];
  displayOrder: number;
}

export interface GetDemographicsResponse {
  questions: DemographicQuestion[];
}

/**
 * Types for POST /assessments/invites/:inviteId/demographics (SubmitDemographicsRequest).
 */
export interface DemographicResponseItem {
  questionKey: string;
  selectedValues: string[];
}

export interface SubmitDemographicsRequest {
  employeeId?: string;
  responses: DemographicResponseItem[];
}

export function getLocalizedLabel(text: ResolvedLocalizedContent): string {
  return text.value ?? "";
}
